// extracted by mini-css-extract-plugin
export default {"navBarMobile":"Navbar_navBarMobile__B9C5e","navBarDesktop":"Navbar_navBarDesktop__WDzLS"};